import { useContext, useEffect } from 'react';
import { AdPageInitContext } from 'routing/main-3-ads-page-change-init-provider.js';
import { IAdvertFuseProps } from './types.js';

export const AdvertFuseCore = ({
  fuseTag,
  origin,
  fuseDataAttr,
  forceMrecSpace,
}: Pick<IAdvertFuseProps, 'fuseTag' | 'origin' | 'forceMrecSpace'> & {
  fuseDataAttr: Record<string, string>;
}) => {
  const { setBannerAdReady } = useContext(AdPageInitContext);

  useEffect(() => {
    if (origin === 'adv-banner') {
      setBannerAdReady?.(true);
    }

    /** When fuseDataAttr updates the element will update so this needs to be in the useEffect */
  }, [setBannerAdReady, origin, fuseDataAttr]);

  if (fuseTag) {
    /**
     * Note: HTMLComment causes the ad to break when loaded in a modal/portal
     *  <HTMLComment text={adUnitPath} />
     */
    return (
      <div
        {...fuseDataAttr}
        className={forceMrecSpace ? 'Mrec-min-height' : ''}
        data-fuse={fuseTag}
        data-dd-action-name={`interstitial-ad-action-${origin ?? ''}`}
        id={fuseTag}
      />
    );
  }
  return null;
};
// advert-fuse.jsx:60 [ADVERT FUSE] 21834192510 / /9734223/NewSite_TopTile / [LOAD]
// advert-fuse.jsx:60 [ADVERT FUSE] 21825811305 / /9734223/HPBackground_NewSite_V2 / [LOAD]
// advert-fuse.jsx:60 [ADVERT FUSE] 21816204874 / /9734223/SideBanner_NewSite_V2 / [LOAD]
// advert-fuse.jsx:60 [ADVERT FUSE] 21816129188 / /9734223/SideBanner2_NewSite_V2 / [LOAD]

// advert-fuse.jsx:83 /9734223/LeftSkin_NewSite_V2
// advert-fuse.jsx:84 targeting:type = rural
